// import About from "./components/about/About";
import CallUs from "./components/contact/CallUs";
import DoYouKnow from "./components/doYouKnow/DoYouKnow";
import Faq from "./components/faq/Faq";
import SocialHandles from "./components/footer/SocialHandles";
import Gallery from "./components/gallery/Gallery";
import Header from "./components/header/Header";
import PropertyListing from "./components/properties/PropertyListing";
import Services from "./components/services/Services";
import MediaList from "./components/video/MediaList";
// import Testimonies from "./components/testimonies/Testimonies";

// import { useSelector, useDispatch } from 'react-redux';
// import { persistor } from './redux/store';
// import { changeMedia, resetReduxToolkitState } from "./redux/mediaSlice";

export default function Home() {
    // const dispatch = useDispatch();

    // const handleLogout = () => {
    //     dispatch(resetReduxToolkitState); 
    //     persistor.purge();       // clear persisted data from localStorage        
    // };

    return <>    
        <div className="container-xxl bg-white p-0">   
            {/* <button onClick={handleLogout}>Reset Redux State</button>; */}

            <Header />
            {/* <Search /> */}
            <Services />
            {/* <About /> */}
            <PropertyListing />
            <CallUs />
            {/* <Agents /> */}
            {/* <Testimonies /> */}                    
            <Faq />
            <SocialHandles />
            <DoYouKnow />                   
            <Gallery />
            <MediaList />    
        </div>
    </>
}